import Panel from '@/components/panel/Panel.jsx';
import { BiText } from '@/components/react-icons/main';
import argumentSelectors from '@/redux/selectors/argumentSelectors';
import nestWorkflowArguments from '@/screens/workflows/workflowEditor/workflowEditorPanels/primaryPanels/appPanel/lib/nestWorkflowArguments.js';
import { randomId } from '@shared/utils/randomId.js';
import { sortByProp } from '@shared/utils/sortByProp.js';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import ArgumentCustomArguments from '../ArgumentCustomArguments.jsx';
import ArgumentInputRow from '../ArgumentInputRow.jsx';
import SliderClose from './SliderClose.jsx';
import SliderHeader from './SliderHeader.jsx';
import SliderTitle from './SliderTitle.jsx';
import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors.js';
import { query } from '@/redux/selectors/querySelectors.js';
import memoizeSelector from '@/redux/lib/memoizeSelector.js';
import AdvancedArgumentsSection from '../argumentsWrapper/AdvancedArgumentsSection.jsx';

const FieldsSlider = ({ onClose, dataSource, dataSourcePath, dataSavePath, lookupActionId, overrideAction, isFunction, stepFunction }) => {
  const [argsKeySeed] = useState(randomId());
  const stepId = useArgSelector(query, 'stepId');
  const publishedFunction = useSelector((state) => state.workflow.publishedWorkflows?.find((n) => n.id === stepFunction?.id));
  const action = useArgSelector(argumentSelectors[dataSource].activeAction({ lookupActionId, overrideAction }), lookupActionId);

  const customArgumentsAreEnabled = !!action?.features?.customArguments?.isActive;
  const actionArguments = action?.[dataSourcePath];
  const currentFunction = publishedFunction || stepFunction;
  const functionInputs = currentFunction?.steps?.find((n) => n?.appSlug === 'functionInputs')?.options?.inputArguments;
  const relevantArguments = isFunction ? functionInputs : actionArguments;
  const actionDefinitions = relevantArguments?.filter((arg) => arg?.hidden !== true)?.sort(sortByProp('sequence')) || [];
  const allArguments = useSelector(memoizeSelector(`values-${stepId || lookupActionId}`, (state) => nestWorkflowArguments(actionDefinitions, argumentSelectors[dataSource].activeArguments({ lookupActionId, overrideAction })(state, lookupActionId), '')));

  const argumentValues = useSelector(argumentSelectors[dataSource].activeArguments({ lookupActionId, overrideAction }), lookupActionId);

  const filteredArguments = allArguments?.filter((argument) => {
    if (!argument?.dependencies?.length) return true;
    return argument.dependencies.every((depId) => {
      const argKey = actionArguments?.find((arg) => arg.id === depId)?.key;

      const depValue = argumentValues?.[argKey];
      return depValue !== undefined && depValue !== null && depValue !== '';
    });
  });

  const basicArguments = filteredArguments?.filter((n) => !n?.isAdvanced);
  const advancedArguments = filteredArguments?.filter((n) => n?.isAdvanced);

  return (
    <>
      <SliderHeader showRun onClose={onClose} />
      <SliderTitle //
        icon={BiText}
        title="Configure Fields"
        description="Configure the data passed to this action."
      />
      <Panel.Section title="Fields" key={argsKeySeed}>
        {basicArguments?.map((argument, idx) => (
          <ArgumentInputRow key={argument.id ? `${argument.id}-${idx}` : idx} argument={argument} definitions={actionDefinitions} definition={action} dataSource={dataSource} dataSourcePath={dataSourcePath} dataSavePath={dataSavePath} />
        ))}
        {customArgumentsAreEnabled && dataSource !== 'customArgs' && <ArgumentCustomArguments definition={action} dataSource={dataSource} dataSourcePath={dataSourcePath} dataSavePath={dataSavePath} />}
      </Panel.Section>
      {!!advancedArguments?.length && <AdvancedArgumentsSection advancedArguments={advancedArguments} dataSource={dataSource} actionDefinitions={actionDefinitions} dataSourcePath={dataSourcePath} dataSavePath={dataSavePath} action={action} />}
      <SliderClose onClose={onClose} />
    </>
  );
};

export default FieldsSlider;
